__turbopack_context__.v({
  "className": "playfair_display_d75971fc-module__qn-apa__className",
  "variable": "playfair_display_d75971fc-module__qn-apa__variable",
});
